import "../styles/contact.scss";

const Contact = () => {
  return (
    <div className="container-outer contact-bg">
      <div className="container container-full contact">
        <div className="contact-left">
          <h1>Let’s Chat & Plan Your Perfect Shoot!</h1>
          <p>
            I’d love to hear from you! Whether you’re ready to book or just have
            a few questions, reach out, and I’ll be in touch soon.
            Let’s create something beautiful together!
          </p>
        </div>
        <div className="contact-right">
          <div className="contact-right-content">
            <p2>Instagram</p2>
            <p className="contact-right-content-block">The fastest way to reach me is through Instagram via direct message at <a className="underline" href="https://www.instagram.com/terravo.photos/">@terravophotos</a>.</p>
            <p2>Email</p2>
            <p className="contact-right-content-block">You can also email me anytime at <a href="mailto:terravophotos@gmail.com" className="underline">terravophotos@gmail.com</a>, and I'll get back to you as soon as possible.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
